export default __webpack_public_path__ + "static/media/Town_barber.acb1eea8.jpg";